import { useState } from "react";

export const useIdempotencyKey = (): string => useState(() => crypto.randomUUID())[0];
